<div #cardContainer *ngIf="cardsSorted" style="display: flex; flex-direction: row; flex: 1; flex-wrap: wrap">
  <!-- Left Column -->
  <div style="display: flex; flex-direction: column; flex: 1; min-width: 400px;" class="print-app-card" >
    <app-card *ngFor="let card of cardsLeft" [card]="card"></app-card>
  </div>
  <!-- Right Column -->
  <div style="display: flex; flex-direction: column; flex: 1; min-width: 400px;" class="print-app-card">
    <app-card *ngFor="let card of cardsRight" [card]="card"></app-card>
  </div>
</div>
